import type { DependenciesDispatchProps } from '@atlassian/jira-portfolio-3-local-storage-commands';
import { setIssueFilter } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/dependencies';
import type { MapDispatchToPropsSimple } from '@atlassian/jira-portfolio-3-portfolio/src/common/types/redux';

const mapDispatchToProps: MapDispatchToPropsSimple<DependenciesDispatchProps> = (dispatch) => ({
	changeIssueFilter: (issueId: string) => {
		dispatch(setIssueFilter(issueId));
	},
});

export default mapDispatchToProps;
